import { render, staticRenderFns } from "./Pagiation.vue?vue&type=template&id=1120be18"
import script from "./Pagiation.vue?vue&type=script&lang=js"
export * from "./Pagiation.vue?vue&type=script&lang=js"
import style0 from "./Pagiation.vue?vue&type=style&index=0&id=1120be18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports